import { createRouter, createWebHashHistory } from "vue-router";
import i18n from "@/locales";

const routes = [
  // ==========================================
  // 官网路由（你现有的全部保留，嵌套在 MainLayout 中）
  // ==========================================
  {
    path: "/",
    component: () => import("@/layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("@/views/Home.vue"),
        meta: { title: "nav.home" },
      },
      {
        path: "about",
        name: "AboutUs",
        component: () => import("@/views/about/AboutUs.vue"),
        meta: { title: "nav.about" },
        children: [
          {
            path: "companyIntro",
            name: "CompanyProfile",
            component: () => import("@/views/about/CompanyProfile.vue"),
            meta: { title: "nav.companyIntro" },
          },
          {
            path: "culture",
            name: "Culture",
            component: () => import("@/views/about/Culture.vue"),
            meta: { title: "nav.culture" },
          },
          {
            path: "news",
            name: "News",
            component: () => import("@/views/about/News.vue"),
            meta: { title: "nav.news" },
          },
          {
            path: "newsDetail/:id",
            name: "NewsDetail",
            component: () => import("@/views/about/NewsDetail.vue"),
            meta: { title: "nav.newsDetail" },
          },
          {
            path: "honors",
            name: "Honors",
            component: () => import("@/views/about/Honors.vue"),
            meta: { title: "nav.honors" },
          },
        ],
      },
      {
        path: "product",
        name: "ProductCenter",
        component: () => import("@/views/ProductCenter.vue"),
        meta: { title: "nav.product" },
      },
      {
        path: "productDetail/:id",
        name: "ProductDetail",
        component: () => import("@/views/ProductDetail.vue"),
        meta: { title: "nav.productDetail" },
      },
      {
        path: "strength",
        name: "Comprehensive",
        component: () => import("@/views/strength/Comprehensive.vue"),
        meta: { title: "nav.strength" },
        children: [
          {
            path: "qualityAssurance",
            name: "QualityAssurance",
            component: () => import("@/views/strength/QualityAssurance.vue"),
            meta: { title: "nav.qualityAssurance" },
          },
          {
            path: "innovation",
            name: "Innovation",
            component: () => import("@/views/strength/Innovation.vue"),
            meta: { title: "nav.innovation" },
          },
          {
            path: "SmartManufacturing",
            name: "SmartManufacturing",
            component: () => import("@/views/strength/SmartManufacturing.vue"),
            meta: { title: "nav.SmartManufacturing" },
          },
          {
            path: "laboratory",
            name: "Laboratory",
            component: () => import("@/views/strength/Laboratory.vue"),
            meta: { title: "nav.laboratory" },
          },
        ],
      },
      {
        path: "recruitment",
        name: "Recruitment",
        component: () => import("@/views/about/Recruitment.vue"),
        meta: { title: "nav.recruitment" },
      },
      {
        path: "contact",
        name: "ContactUs",
        component: () => import("@/views/ContactUs.vue"),
        meta: { title: "nav.contact" },
      },
    ],
  },

  // ==========================================
  // 👇 新增：微信公众号路由（独立布局，无 Header/Footer）
  // ==========================================
  {
    path: "/wechat",
    component: () => import("@/layouts/WechatLayout.vue"),
    redirect: "/wechat/introduction",
    children: [
      {
        path: "introduction",
        name: "Introduction",
        component: () => import("@/views/wechat/Introduction.vue"),
        meta: { title: "nav.wechat.introduction" },
      },
      {
        path: "product",
        name: "Product",
        component: () => import("@/views/wechat/Product.vue"),
        meta: { title: "nav.wechat.product" },
      },
      {
        path: "product_Detail/:id",
        name: "Product_Detail",
        component: () => import("@/views/wechat/ProductDetail.vue"),
        meta: { title: "nav.wechat.productDetail" },
      },
      {
        path: "applicationResume",
        name: "ApplicationResume",
        component: () => import("@/views/wechat/ApplicationResume.vue"),
        meta: { title: "nav.wechat.applicationResume" },
      },
    ],
  },

  // 404 兜底
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith("/wechat")) {
    document.title = i18n.global.t(to.meta.title) || "HCB";
  } else {
    document.title = `HCB-${i18n.global.t(to.meta.title) || "HCB"}`;
  }
  next();
});

export default router;
